import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://lavmquwasqqjcihbukjq.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxhdm1xdXdhc3FxamNpaGJ1a2pxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUxOTQwMjgsImV4cCI6MjA5MDc3MDAyOH0.0UScE4npkwLkD9lwv0hlQehzdU_DOMXz3NsFS9cFE6Q';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } });

// ── Transform helpers ──────────────────────────
const toCamel = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const result = {};
  for (const [k, v] of Object.entries(obj)) {
    result[k.replace(/_([a-z])/g, (_, l) => l.toUpperCase())] = v;
  }
  return result;
};

const toSnake = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const result = {};
  for (const [k, v] of Object.entries(obj)) {
    result[k.replace(/[A-Z]/g, l => '_' + l.toLowerCase())] = v;
  }
  return result;
};

const camelize = (arr) => (arr || []).map(toCamel);

export const getMessages = async (clinicId, clientId) => {
  const { data } = await supabase.from('messages')
    .select('*').eq('clinic_id', clinicId).eq('client_id', clientId)
    .order('sent_at', { ascending: true });
  return camelize(data || []);
};

export const sendMessage = async (msg) => {
  const { data, error } = await supabase.from('messages').insert(toSnake(msg)).select().single();
  if (error) throw new Error(error.message);
  return toCamel(data);
};

export const markMessagesRead = async (clinicId, clientId, sender) => {
  await supabase.from('messages')
    .update({ read: true })
    .eq('clinic_id', clinicId).eq('client_id', clientId)
    .eq('sender', sender).eq('read', false);
};

export const getUnreadCount = async (clinicId) => {
  const { count } = await supabase.from('messages')
    .select('*', { count: 'exact', head: true })
    .eq('clinic_id', clinicId).eq('sender', 'client').eq('read', false);
  return count || 0;
};

export const logError = async ({ clinicId, userId, action, error, context = {} }) => {
  try {
    await supabase.from('error_logs').insert({
      clinic_id: clinicId || null,
      user_id: userId || null,
      action: action || 'unknown',
      error_message: error?.message || String(error),
      error_code: error?.code || null,
      context,
      created_at: new Date().toISOString(),
    });
  } catch (_) {
    console.error('[logError failed]', _);
  }
};

export const getErrorLogs = async () => {
  const { data } = await supabase.from('error_logs')
    .select('*').order('created_at', { ascending: false }).limit(200);
  return (data || []).map(toCamel);
};

export const resolveError = async (id) => {
  await supabase.from('error_logs').update({ resolved: true }).eq('id', id);
};
